import React from 'react'
import About from '../components/about/About'
import Counters from '../components/counter/Counters'
import Testimonials from '../components/testimonials/Testimonials'
import { NavLink } from 'react-router-dom'


function AboutUs() {


    return (
        <>
            <section className="section-breadcrumb">
                <div className="top_outline_01"></div>
                <div className="top_outline_02"></div>
                <div className="bottom_outline_01"></div>
                <div className="bottom_outline_02"></div>
                <div className="container-fulid">
                    <div className="row">
                        <div className="col-12">
                            <div className="zx-breadcrumb padding-tb-100">
                                <div className="banner mb-15 justify-content-center">
                                    <h2>About Us</h2>
                                </div>
                                <div className="entry-breadcrumb">
                                    <h5>
                                        <span>
                                            <NavLink to="/">Home</NavLink>
                                        </span>
                                        <span> / </span>
                                        <span className="post-page">
                                            <NavLink to="/about">About Us</NavLink>
                                        </span>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <About />
            <Counters />
            <Testimonials />
        </>
    )
}

export default AboutUs
